import { render, staticRenderFns } from "./BaiduLeadReviewList.vue?vue&type=template&id=499e592d&scoped=true"
import script from "./BaiduLeadReviewList.vue?vue&type=script&lang=js"
export * from "./BaiduLeadReviewList.vue?vue&type=script&lang=js"
import style0 from "./BaiduLeadReviewList.vue?vue&type=style&index=0&id=499e592d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e592d",
  null
  
)

export default component.exports